import React from 'react';
import { vaccinationData } from './VaccinationTable';

const VaccinationSchedule = () => {
  return (
    <div className="p-4 text-sm bg-white text-blue-800">
      <div className="mb-8">
        <h3 className="text-xl font-bold mb-4 text-purple-600">Vaccination Schedule</h3>
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white text-blue-800 border border-gray-300">
            <thead>
              <tr>
                <th className="px-4 py-2 border-b border-r text-white bg-blue-600">Age</th>
                <th className="px-4 py-2 border-b border-r text-white bg-blue-600">Vaccine Name</th>
                <th className="px-4 py-2 border-b border-r text-white bg-blue-600">Dose</th>
              </tr>
            </thead>
            <tbody>
              {vaccinationData.map((data, index) => (
                <React.Fragment key={index}>
                  <tr className="bg-gray-100">
                    <td className="px-4 py-2 border-b border-r text-blue-800 font-semibold" rowSpan={data.vaccines.length}>
                      {data.age}
                    </td>
                    <td className="px-4 py-2 border-b border-r text-blue-800">{data.vaccines[0]?.name}</td>
                    <td className="px-4 py-2 border-b border-r text-blue-800">{data.vaccines[0]?.dose}</td>
                  </tr>
                  {data.vaccines.slice(1).map((vaccine, vIndex) => (
                    <tr key={vIndex} className="bg-white">
                      <td className="px-4 py-2 border-b border-r text-blue-800">{vaccine.name}</td>
                      <td className="px-4 py-2 border-b border-r text-blue-800">{vaccine.dose}</td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default VaccinationSchedule;
